import { createRouter, createWebHistory } from 'vue-router';

//视图
import Home from './components/Views/HomePage.vue';
import DocumentReader from './components/Views/DocumentReader.vue'
import SearchResult from './components/Views/SearchResult.vue'

//错误
import Error404 from './components/Views/err/404.vue';
// import { path } from 'apt';

const routes = [
  //视图
  { path: '/', name: 'vc-home', component: Home },
    { path: '/read', alias: '/docs/read', name: 'DocumentReader', component: DocumentReader },
  {
    path: '/search',
    alias: '/docs/search',
    name: 'search',
    component: SearchResult
  },
  // Retired chat bookmarks lead back to public documentation without loading chat code.
  { path: '/livechat', alias: '/docs/livechat', redirect: { name: 'vc-home', query: {} } },




  { path: '/redirect', redirect: { name: 'vc-home', query: {} } },

  //错误
  { path: '/404', name: 'vc-Error404', component: Error404 },

  // 捕获所有未定义的路由，跳转到 404 页面
  { path: '/:pathMatch(.*)*', name: 'Error404', component: Error404 },
];

const router = createRouter({
  history: createWebHistory(), // 使用 HTML5 的历史模式
  routes,
});

export default router;